import { paths } from '../../common/constants/pathVariables.js';
import { omaElisaForCompaniesMsg, quotesMsg, t } from '../../common/i18n/index.js';
import { ProductOfferingsLayoutCoCo } from '../SubscriptionsLayout/ProductOfferingsLayoutCoCo.js';
import { QuotesListCoCo } from './QuotesListCoCo';

export const QuotesCoCo = () => {
  return (
    <ProductOfferingsLayoutCoCo
      breadCrumbs={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.J63R(quotesMsg) },
      ]}
    >
      <QuotesListCoCo />
    </ProductOfferingsLayoutCoCo>
  );
};
